import { Flow_Parameter__User__Input } from '~/graphql/types';
import { UserParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (
  parameterValue: UserParameterValue,
): Flow_Parameter__User__Input => {
  switch (parameterValue.type) {
    case PARAMETER_VALUE_TYPE.USER_PRIMITIVE:
      if (parameterValue.value == null) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} value is not identified`,
        );
      }

      return {
        User: {
          Primitive: {
            value: parameterValue.value,
          },
        },
      };
    case PARAMETER_VALUE_TYPE.USER_POINTER:
      if (
        parameterValue.variable == null ||
        parameterValue.variable.field == null
      ) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} has no field`,
        );
      }

      return {
        User: {
          Pointer: {
            variable: parameterValue.variable.name,
            field: parameterValue.variable.field.name,
          },
        },
      };
    default:
      throw new Error(
        `Field value input conversion cannot handle type (${JSON.stringify(
          parameterValue,
          null,
          2,
        )}`,
      );
  }
};
